import React from "react";
import { pick } from "lodash";
import connectToMedia from "../../../Media/connectToMedia";
import AnimatorContainer from "./AnimatorContainer";
import PropsToStateComponent from "../../../../utilities/transcriptLib/PropsToStateComponent";
import connectToTranscript from "../connectToTranscript";

const mapStateToProps = (state) => {
  return { ...state.media, skipPrevNextHit: state.media.skipPrevNextHit };
};

class AnimatorPlayerFilter extends PropsToStateComponent {
  propsToState(pProps) {
    const props = pProps || this.props;
    return pick(
      super.propsToState(props),
      "identifiedRangeBrackets,identifiedRanges,currentTime,currentPosition,paused,onSeek,skipPrevNextHit,onSkipPrevNextHit".split(
        ","
      )
    );
  }

  render() {
    return <AnimatorContainer {...this.state} />;
  }
}

export default connectToMedia(mapStateToProps)(
  connectToTranscript(AnimatorPlayerFilter)
);
